import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

import { EuiCard, EuiFlexGroup, EuiFlexItem } from "@elastic/eui";

export default function LatestArticle() {
  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup
          gutterSize="l"
          direction="row"
          style={{ margin: "0 7px" }}
        >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Recording_Menu/Photoseries/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Task_Menu/1440pCGIs-WebUI_Task_Photoseries.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Recording Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Fotoserie"
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <Link to="/1440p_Series_CGI_List/Recording_Menu/Video/">
                  <StaticImage
                    src="../../../images/1440p_Series_CGI_List/Task_Menu/1440pCGIs-WebUI_Task_Video.png"
                    alt="UltraHD Series (2K+ 1440p & 4K 2160p) CGI List - Recording Menu"
                    placeholder="dominantColor"
                    formats={["auto", "webp", "avif"]}
                    loading="lazy"
                  />
                </Link>
              }
              title="Video"
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </React.Fragment>
  );
}
